// Fetches the user's country code and name from browsing context
function fetchUserCountry() {
  // CUSTOM CODE: Use the current language path (e.g. /de/), so the country name comes back in that language
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const url = `${window.shopUrl}${root}browsing_context_suggestions.json`;
  console.log('Fetching user country from:', url); // Debug log

  return fetch(url)
    .then(response => {
      console.log('Received response:', response.status); // Debug log
      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`); // Debug log
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Fetched user country data:', data); // Debug log
      return {
        code: data.detected_values.country.handle,
        name: data.detected_values.country.name
      };
    })
    .catch(error => console.error("Fetch error:", error.message));
}

// Fetches shipping times for a given country code using the JSON file URL
function fetchShippingTimes(countryCode) {
  console.log('Fetching shipping times for country code:', countryCode); // Debug log
  return fetch(customShippingTimesJsonUrl)
    .then(response => {
      console.log('Shipping times fetch response:', response.status); // Debug log
      return response.json();
    })
    .then(data => {
      console.log('Shipping times data:', data); // Debug log
      return data[countryCode];
    })
    .catch(error => console.error("Error fetching shipping times:", error.message));
}

// Updates the HTML document with the earliest and latest shipping times, country name, and flag icon
function updateShippingInfo(earliest, latest, countryName, countryCode) {
  console.log('Updating shipping info with:', { earliest, latest, countryName, countryCode }); // Debug log

  const newClass = `flag-icon-${countryCode.toLowerCase()}`;

  // CUSTOM CODE: Shipping lines rendered by snippets/custom-shipping-eta.liquid (below the price on the
  // product page, below Add to cart elsewhere). They use data attributes instead of ids, so there can be more than one.
  document.querySelectorAll('[data-shipping-eta]').forEach((line) => {
    line.querySelector('[data-shipping-earliest]').textContent = earliest;
    line.querySelector('[data-shipping-latest]').textContent = latest + window.orderProcessingDays;
    line.querySelector('[data-shipping-country]').textContent = countryName;
    line.querySelector('[data-shipping-flag]').className = `flag-icon ${newClass}`;
    line.hidden = false;
    line.closest('[data-shipping-eta-container]')?.classList.add('is-shipping-eta-loaded');
  });
}

// Retrieves or updates the shipping information based on the user's current country
function handleShippingInfo() {
  console.log('Handling shipping info'); // Debug log
  fetchUserCountry().then(({ code, name }) => {
    console.log('User country:', { code, name }); // Debug log
    const storedShippingInfo = localStorage.getItem('shippingInfo');
    const shippingInfoObj = storedShippingInfo ? JSON.parse(storedShippingInfo) : {};

    console.log('Stored shipping info:', shippingInfoObj); // Debug log

    if (shippingInfoObj.countryCode !== code || !shippingInfoObj.shippingTimeEarliest || !shippingInfoObj.shippingTimeLatest) {
      console.log('Shipping info needs to be updated or fetched'); // Debug log
      fetchShippingTimes(code).then(times => {
        if (times) {
          console.log('Fetched shipping times:', times); // Debug log
          localStorage.setItem('shippingInfo', JSON.stringify({
            countryCode: code,
            shippingTimeEarliest: times.shippingTimeEarliest,
            shippingTimeLatest: times.shippingTimeLatest
          }));
          updateShippingInfo(times.shippingTimeEarliest, times.shippingTimeLatest, name, code);
        } else {
          console.warn('No shipping times found for country code:', code); // Debug log
        }
      });
    } else {
      console.log('Using stored shipping info'); // Debug log
      updateShippingInfo(shippingInfoObj.shippingTimeEarliest, shippingInfoObj.shippingTimeLatest, name, code);
    }
  }).catch(error => console.error('Error in handleShippingInfo:', error.message));
}

// Initializes the functionality when the document is ready.
// CUSTOM CODE: The script is loaded async, so the document can already be ready when it runs.
// Then DOMContentLoaded has already fired, so run right away instead of waiting for it.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('Document ready, initializing shipping info'); // Debug log
    handleShippingInfo();
  });
} else {
  handleShippingInfo();
}